import { NAVIGATION_LINKS_DEFAULT_VALUES } from '~/lib/util/defaultLinks'

// Used to store utility values on a Local Storage like sitewide, sitelinks, bestsellers and recently viewed
export const state = () => ({
  // The Sitewide
  sitewide: {},

  // The Sitewide Mobile version
  sitewidemobile: {},

  // The Site Links Mobile version
  sitelinks: [],

  // The Site Links
  sitelinksmobile: [],

  // The Best Sellers Links
  bestsellers: [],

  // The timestamp used as cache-braker
  timestamp: undefined,

  // The Promo Header Banners used as per GLOBAL settings
  DEAFULT_RAW_promoheaderbanners: [],

  // The DEFAULT Promo Header Banners PARSED
  DEAFULT_promoheaderbanners: {},

  // The Promo Header Banners used as per LOCAL settings
  SCOPED_RAW_promoheaderbanners: [],

  // The SCOPED Promo Header Banners PARSED
  SCOPED_promoheaderbanners: {}
})

export const mutations = {
  sitewide(state, value) {
    state.sitewide = { ...value }
  },

  sitewidemobile(state, value) {
    state.sitewidemobile = { ...value }
  },

  sitelinks(state, values) {
    state.sitelinks = [...values]
  },

  sitelinksmobile(state, values) {
    state.sitelinksmobile = [...values]
  },

  bestsellers: (state, payload) => {
    state.bestsellers = payload
    return state.bestsellers
  },

  timestamp: (state, payload) => {
    state.timestamp = payload
    return state.timestamp
  },

  DEAFULT_RAW_promoheaderbanners: (state, payload) => {
    // console.info('UTILITY mutation DEAFULT_RAW_promoheaderbanners', payload)
    state.DEAFULT_RAW_promoheaderbanners = { ...payload }
    return state.DEAFULT_RAW_promoheaderbanners
  },

  DEAFULT_promoheaderbanners: (state, payload) => {
    state.DEAFULT_promoheaderbanners = { ...payload }
    return state.DEAFULT_promoheaderbanners
  },

  SCOPED_RAW_promoheaderbanners: (state, payload) => {
    state.SCOPED_RAW_promoheaderbanners = { ...payload }
    return state.SCOPED_RAW_promoheaderbanners
  },

  SCOPED_promoheaderbanners: (state, payload) => {
    state.SCOPED_promoheaderbanners = { ...payload }
    return state.SCOPED_promoheaderbanners
  }
}

export const getters = {
  sitewide: state => {
    return state.sitewide
  },

  sitewidemobile: state => {
    return state.sitewidemobile
  },

  sitelinks: state => {
    return (state?.sitelinks?.length > 0 && state.sitelinks) || NAVIGATION_LINKS_DEFAULT_VALUES
  },

  sitelinksmobile: state => {
    return (
      (state?.sitelinksmobile?.length > 0 && state.sitelinksmobile) || (state?.sitelinks?.length > 0 && state.sitelinks.slice(0, 8)) || NAVIGATION_LINKS_DEFAULT_VALUES.slice(0, 8)
    )
  },

  bestsellers(state) {
    return (state.bestsellers.length > 0 && state.bestsellers) || []
  },

  timestamp(state) {
    return state.timestamp || Date.now()
  },

  DEAFULT_RAW_promoheaderbanners(state) {
    if (state.DEAFULT_RAW_promoheaderbanners?.enabled === false) {
      return undefined
    }
    if (state.DEAFULT_RAW_promoheaderbanners?.banners?.length === 0) {
      return undefined
    }

    return state.DEAFULT_RAW_promoheaderbanners.banners
  },

  DEAFULT_promoheaderbanners(state) {
    return state.DEAFULT_promoheaderbanners
  },

  SCOPED_RAW_promoheaderbanners(state) {
    if (state.SCOPED_RAW_promoheaderbanners?.enabled === false) {
      return undefined
    }
    if (state.SCOPED_RAW_promoheaderbanners?.banners?.length === 0) {
      return undefined
    }

    return state.SCOPED_RAW_promoheaderbanners.banners
  },

  SCOPED_promoheaderbanners(state) {
    return state.SCOPED_promoheaderbanners
  }
}
